// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2EXqp","header":"MergedInvoice_header__1sbKj"};